class DuplicateTicketTemplateWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.state = this.injector.get('$state');
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');

        this.key = 'duplicate-ticket-template';
        this.title = this.translate.instant('tickets.templates.workflows.details.duplicate');
        this.level = 'highlight';
        this.icon = 'copy';
    }

    action(template, controllerInstance) {
        this.api
            .post(`tickets/templates/${template.id}/duplicate`)
            .then(({data}) => {
                this.alert.success(
                    this.translate.instant('general.alerts.duplication_success.title'),
                    this.translate.instant('general.alerts.duplication_success.content'),
                );

                controllerInstance.allowRoute = true;

                this.state.go('app.tickets.templates.edit', {
                    id: data.data.id
                });
            })
            .catch(err => {
                this.alert.error(
                    this.translate.instant('general.alerts.duplication_error.title'),
                    this.translate.instant('general.alerts.duplication_error.content'),
                )
            });
    }

}

angular
    .module('festzelt-os.modules.tickets.templates')
    .factory('duplicateTicketTemplate', [
        '$injector',
        ($injector) => new DuplicateTicketTemplateWorkflow($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/workflows/details/duplicate.js